import axios from "axios";
import firebase from "./firebase";

const config = {
    // baseURL: "http://localhost:8001/api", // 로컬 테스트시
    baseURL: "/api", // 배포시
    // baseURL: "http://youngmap.cafe24app.com/api",
    timeout: 30000,
  },
  instance = axios.create(config);
const confmKey = "U01TX0FVVEgyMDIwMDMyNzAwNTg0OTEwOTU5MjE="; //"U01TX0FVVEgyMDIzMDcxNzIwMDAxNDExMzkzNjg=";
const confmKey2 = "U01TX0FVVEgyMDIwMDMyNzAwNTc0MzEwOTU5MjA=";

//로그인
// export const userAuth = (params) => instance.post('/auth/google',params);//로그인
export const googleLogin = () => {
  const provider = new firebase.auth.GoogleAuthProvider();
  provider.setCustomParameters({
    prompt: "select_account",
  });
  return firebase.auth().signInWithRedirect(provider);
};

export const emailLogin = (data) => {
  const { email, password } = data;
  return firebase.auth().signInWithEmailAndPassword(email, password);
};

export const passwordReset = (email) => {
  return firebase.auth().sendPasswordResetEmail(email);
};

export const getUser = (params) => {
  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        firebase
          .auth()
          .currentUser.getIdToken()
          .then((token) => {
            instance.defaults.headers.common["Authorization"] =
              "Bearer " + token;
            instance
              .get("/user/detail", params)
              .then((res) => resolve(res))
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      } else {
        resolve(null);
      }
    });
  });
};
export const logOut = () => firebase.auth().signOut();
export const userAuth = (params) => instance.post("/user/auth", params);
export const getCustomerList = (params) =>
  instance.get("/customer/list", { params: params }); //로그인
export const getCustomerAllList = (params) => instance.get("/customer/all"); //로그인
export const createCustomer = (params) =>
  instance.post("/customer/create", params); //로그인
export const createCustomerDoc = (params) =>
  instance.post("/customer/doc/create", params); //로그인
export const updateCustomer = (params) =>
  instance.patch("/customer/update", params); //로그인
export const deleteCustomer = (params) =>
  instance.delete("/customer/delete", { data: params }); //로그인
export const getDetailCustomer = (params) =>
  instance.get("/customer/detail", { params: params }); //로그인
export const getAddress = (params) => instance.get("/customer/address", params); //로그인
export const GetSearchList = (params) =>
  axios.get("https://www.juso.go.kr/addrlink/addrLinkApi.do", {
    params: {
      ...params,
      confmKey,
      currentPage: 1,
      countPerPage: 50,
      resultType: "json",
    },
  });
export const GetSearchDetail = (params) =>
  axios.get("https://www.juso.go.kr/addrlink/addrCoordApi.do", {
    params: { ...params, confmKey: confmKey2, resultType: "json" },
  });
